import { render } from "./tab_currencies.vue?vue&type=template&id=979459e4&scoped=true"
import script from "./tab_currencies.vue?vue&type=script&lang=js"
export * from "./tab_currencies.vue?vue&type=script&lang=js"

import "./tab_currencies.vue?vue&type=style&index=0&id=979459e4&scoped=true&lang=css"

import exportComponent from "/app/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-979459e4"]])

export default __exports__